<ng-container *ngIf="mode === 'view'">
  <div class="field field_size_{{ size ? size : 'l' }}">
    <div class="field__name">{{ name }} &nbsp;</div>

    <app-parse-links class="field__value" [class.no-underline]="noUnderline" [value]="value"></app-parse-links>
  </div>
</ng-container>
